<template>
  <div class="header-index-warp">
    <div class="nav-bar"></div>
    <van-nav-bar title="标题" left-arrow >
      <template #left>
        <img src="@/assets/image/back.png" alt @click="onClickLeft"/>
      </template>
      <template #title>
        <div class="center">
          <p>{{titleName}}</p>
          <img :src="$theme.order_down_arrow" alt v-if="showUp" @click="showMask=!showMask" />
        </div>
      </template>
      <template #right>
        <img src="@/assets/wanning/header.png" alt v-if="showRight" @click="onClickRight"/>
      </template>
    </van-nav-bar>
    <van-overlay :show="showMask" @click="showMask = false">
      <div class="showMask" v-show="showMask" @click.stop>
        <p :class="{'activep':type=='bees'}" @click="jumpJobManage('bees')">
          我的工单管理
          <span  v-if="formData.minePending">{{formData.minePending}}</span>
        </p>
        <p @click="jumpJobManage('group')" :class="{'activep':type=='group'}">
          团队工单管理
          <span v-if="formData.teamPending">{{formData.teamPending}}</span>
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      showMask: false,
      formData:{}
    };
  },
  props: {
    titleName: {
      default: "我的工单管理",
      type: String,
    },
    showUp: {
      default: true,
      type: Boolean,
    },
    showRight: {
      default: true,
      type: Boolean,
    },
    type: {
      default: "bees",
      type: String,
    },
  },
  methods: {
    onClickLeft() {
      utils.goBack();
    },
    onClickRight() {
      this.$router.push({
        path: "beeswarningabout",
      });
    },
    jumpJobManage(item) {
      this.showMask = !this.showMask;
      switch (item) {
        case "bees":
          if (this.type == "bees") {
            return;
          }
          utils.jumpToNewPage({
            url: window.location.origin + "/h5user/beeswarningmanage",
            noTitle: "1",
          });
          break;
        case "group":
          if (this.type == "group") {
            return;
          }
          utils.jumpToNewPage({
            url: window.location.origin + "/h5user/groupwarningmanage",
            noTitle: "1",
          });
          break;
        default:
          break;
      }
    },
    getteamAndMine(){
      this.http({
        url:'/order/manage/warning/app/teamAndMine',
        method:'post'
      }).then(rps=>{
        if(rps.code==200){
          this.formData = rps.data;
        }
      })
    }
  },
  created(){
    this.getteamAndMine();
  }
};
</script>

<style lang="less" scoped>
.header-index-warp {
  position: relative;
  display: block;
  .van-overlay {
    top: 90px;
    background: none;
  }
  .showMask {
    background: url("../../../assets/wanning/bg.png");
    width: 310px;
    height: 181px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    z-index: 99;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 26px;
      color: #333;
      font-weight: 500;
      padding: 15px;
      span {
        width: 28px;
        height: 28px;
        display: inline-block;
        background-color: red;
        border-radius: 20px;
        color: white;
        font-size: 20px;
        text-align: center;
        padding: 2px;
        vertical-align: text-top;
      }
    }
    .activep {
      color: #999;
    }
  }
  .van-nav-bar__left {
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      display: block;
    }
  }
  .van-nav-bar__title {
    font-size: 32px;
    color: #333;
    font-weight: 500;
    .center {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 44px;
        height: 44px;
        display: block;
        object-fit: cover;
      }
    }
  }
  .van-nav-bar__right {
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      display: block;
    }
  }
}
</style>